<div id="notificationsDropDown" class="dropdown d-inline-block">
    <a class="notification dropdown-toggle no-caret pl-2 pr-2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span><i class="fa fa-tasks" (click)="updateTaskViewed()"></i></span>
      <span *ngIf="notificationCount>0" class="b1">{{notificationCount}}</span>
    </a>
<div class="dropdown-menu dropdown-menu-right rounded-0 p-0 mt-3 box-shadow" aria-labelledby="notifications">    
    <div class="clearfix">            
        <ul id="notificationTab" class="nav nav-tabs nav-justified border-0">
            <li class="nav-item">
                <a class="nav-link active transition align-left" data-toggle="tab" (click)="navigateTaskList()"><i class="fa fa-tasks" aria-hidden="true"></i> Task Notifications</a>
            </li>
        </ul>
    </div>
    <div class="tab-content">
        <div class="tab-pane active" id="notifications">
            <div class="list">
                <a *ngFor="let notification of tasknotifications" href="javascript:void(0);" class="transition">
                    <div (click)="navigateTaskList()">
                        <img src="{{folderPath}}/{{notification.created_by_avatar}}" alt="user-img" class="user-img rounded-circle">                    
                        <div class="list-content">
                            <span class="urgent" *ngIf="notification.is_urgent == 1"><i class="fa fa-warning"></i></span>
                            <div  class="unviewed" *ngIf="notification.viewed_at == null">
                                <h3>{{notification.title}} <span class="pull-right"><i class="fa fa-clock-o" title="Task Due Date"></i> {{notification.date_due}}</span></h3>
                                <p> {{notification.notes}}</p>
                            </div>
                            <div  *ngIf="notification.viewed_at != null">
                                <h3>{{notification.title}} <span class="pull-right"><i class="fa fa-clock-o" title="Task Due Date"></i> {{notification.date_due}}</span></h3>
                                <p> {{notification.notes}}</p>
                            </div>
                        </div>
                    </div>
                </a>
            </div> 
        </div>
    </div>
</div>
</div>